import { Component, OnInit, Input, ViewChild, ElementRef, OnChanges, Output,EventEmitter, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';

declare var $:any;
declare var window:any;

@Component({
  selector: 'box-form-pesquisa',
  templateUrl: './box-form-pesquisa.component.html',
  styleUrls: ['./box-form-pesquisa.component.scss']
})
export class BoxFormPesquisaComponent implements OnInit,OnChanges,AfterViewInit {
    
  @Input("show") show       = false;
  @Output("close") close  = new EventEmitter();
  @ViewChild("box") box:ElementRef; 
  @ViewChild("input") input:ElementRef; 
  @Input("template") template = "default";

  public dataItem = {termo: ""}   

  constructor(
    private router: Router
  ){}   

  /**
   * 
   * Buscar
   * 
   */
  buscar(){

    this.show = false;
    this.close.emit(false);
    //$(this.box.nativeElement).slideUp(200);
    this.router.navigate(["/buscar"],{queryParams:this.dataItem});

  }
  setFocusInput(){

    this.input.nativeElement.focus();

  }
  /**
   * 
   * Seta a Class Fixed para o topo
   * 
   */
  setFixed(){

    try{
      
    let box = this.box.nativeElement;
    
    $(window).scroll(function(){ 

      var fromTop = $(this).scrollTop();
      var windowWidth = $(window).width();
      
      //if(fromTop > 100 && windowWidth > 960){
      if(fromTop > 500){
        box.classList.add("animated","fadeIn","fixed");
      }else{
        box.classList.remove("fixed","animated","fadeIn");
      } 

    });

    }catch(e){
      alert(e.message)
    }

  }
  /**
   * 
   * Inicializa as Funções
   * 
   */
  ngOnInit(){
    
  }
  ngOnChanges(changes:any): void {
    
    if(changes.show){
      if(typeof(this.box) != "undefined"){
        if(changes.show.currentValue == true){ 
          $(this.box.nativeElement).slideDown(200);
          this.setFocusInput();
        }else{
          $(this.box.nativeElement).slideUp(200);
        }
      }  
    }

  }
  ngAfterViewInit(): void {
  
  }

}
